import React from 'react';
import pimcoreClient from '../../../apollo/pimcoreClient';
import { NavigationNodesProvider } from './NavigationNodesProvider';

interface SiteNavigationProvidersProps {
    children: React.ReactNode;
}

export const SiteNavigationProviders = ({ children }: SiteNavigationProvidersProps) => {
    return (
        <NavigationNodesProvider apolloClient={pimcoreClient}>{children}</NavigationNodesProvider>
    );
};
